import type { CSSProperties } from 'react';
import * as React from 'react';

import { Row } from '../components/common';
import { useDataGridContext } from '../context';
import { FooterRowColumn } from './footer-row-column';

export const FooterRow = React.forwardRef<HTMLDivElement, { totalWidth: number; style?: CSSProperties }>((props, ref) => {
	const { totalWidth, style } = props;

	const { columns } = useDataGridContext();
	const hasFooter = columns.some(column => column.columnFooter);
	if (!hasFooter) {
		return null;
	}
	return (
		<Row ref={ref} className="root" key={'footer-row'} style={{ ...style, width: totalWidth, minWidth: '100%' }}>
			<FooterRowColumn position="left" />
			<FooterRowColumn />
			<FooterRowColumn position="right" />
		</Row>
	);
});
